// extracted by mini-css-extract-plugin
export var actionButton = "_5f-1";
export var actionButtons = "_5f-2";
export var actions = "_5f-0";
export var aiUnread = "_5f-10";
export var alignCenter = "_5f-h";
export var backWrapper = "_5f-3";
export var cellContainer = "_5f-4";
export var checkboxContainer = "_5f-5";
export var contentContainer = "_5f-6";
export var contentHeader = "_5f-8";
export var conversationsTableWrapper = "_5f-s";
export var draftReplyBadgeContainer = "_5f-m";
export var dropdownItem = "_5f-b";
export var dropdownItemsContainer = "_5f-a";
export var dropdownTitle = "_5f-c";
export var errorIcon = "_5f-7";
export var filter = "_5f-d";
export var gray = "_5f-i";
export var headerActionButtons = "_5f-e";
export var headerCheckboxContainer = "_5f-f";
export var icon = "_5f-j";
export var menuContainer = "_5f-k";
export var noMoreTicketsIcon = "_5f-12";
export var noMoreTicketsSubText = "_5f-13";
export var oneLine = "_5f-l";
export var optionsButton = "_5f-n";
export var plus = "_5f-o";
export var portalButtonsWrapper = "_5f-g";
export var red = "_5f-p";
export var scrolledTop = "_5f-9";
export var search = "_5f-q";
export var selectedConversationsCount = "_5f-r";
export var spinner = "_5f-t";
export var strong = "_5f-u";
export var summaryCell = "_5f-v";
export var tableContainer = "_5f-11";
export var tagContainer = "_5f-w";
export var threeDots = "_5f-x";
export var twoLines = "_5f-y";
export var unread = "_5f-z";